import React from "react"
import {MainCP} from "../../Components/equipo-gobierno/MainCP"

const ViewEquipoGobierno: React.FC = () => <MainCP/>

export default ViewEquipoGobierno;